import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Status } from '@df/core/status';
import { SearchViewComponentDef } from '@df/search/search-view.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ProductListingFiltersComponent } from '../../catalog/ui/listing/filters/product-lisitng-filters.component';
import { ProductListingComponent } from '../../catalog/ui/listing/product-listing.component';
import { CmsOutletBlockComponent } from '../../cms/outlet/block/cms-outlet-block.component';
import { StickyFreeComponent } from '../../common/sticky-free/sticky-free.component';
import { SearchBannerComponent } from '../banner/search-banner.component';
import { SearchViewInputComponent } from './input/search-view-input.component';

@Component({
    selector: 'search-view',
    templateUrl: './search-view.html',
    styleUrl: './search-view.component.scss',
    standalone: true,
    imports: [
        CmsOutletBlockComponent,
        NgClass,
        ProductListingComponent,
        ProductListingFiltersComponent,
        SearchBannerComponent,
        SearchViewInputComponent,
        StickyFreeComponent,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchViewComponent extends SearchViewComponentDef implements OnInit {
    status = new Status();

    override ngOnInit(): void {
        super.ngOnInit();

        this.subscriptions.add(this.status.subscribe(() => this._ref.detectChanges()));
    }

    get hasProductResults(): boolean {
        return !!this.result?.products?.length;
    }
}
